import React from 'react';
import Die from './Die';

export default function DiceLines(props) {
  return <>
    <div className="dice-line" id="dice-line-1">
      <Die pos={0} hasEffect={props.diceHasEffect ? props.diceHasEffect[0] : null} />
      <Die pos={1} hasEffect={props.diceHasEffect ? props.diceHasEffect[1] : null} />
      <Die pos={2} hasEffect={props.diceHasEffect ? props.diceHasEffect[2] : null} />
      <Die pos={6} hasEffect={props.diceHasEffect ? props.diceHasEffect[6] : null} isExtraDie={true} />
    </div>
    <div className="dice-line" id="dice-line-2">
      <Die pos={3} hasEffect={props.diceHasEffect ? props.diceHasEffect[3] : null} />
      <Die pos={4} hasEffect={props.diceHasEffect ? props.diceHasEffect[4] : null} />
      <Die pos={5} hasEffect={props.diceHasEffect ? props.diceHasEffect[5] : null} />
      <Die pos={7} hasEffect={props.diceHasEffect ? props.diceHasEffect[7] : null} isExtraDie={true} />
    </div>
  </>;
}
